import { render, staticRenderFns } from "./giftPackagePrice.vue?vue&type=template&id=82358670&scoped=true&"
import script from "./giftPackagePrice.vue?vue&type=script&lang=js&"
export * from "./giftPackagePrice.vue?vue&type=script&lang=js&"
import style0 from "./giftPackagePrice.vue?vue&type=style&index=0&id=82358670&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82358670",
  null
  
)

export default component.exports